(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    class ArticleMap extends HTMLElement {
    connectedCallback() {
      const content = this.querySelector('[data-article-map-content]');
      const map = this.querySelector('[data-article-map]');
      const list = this.querySelector('[data-article-map-list]');

      if (!content || !map || !list) {
        this.classList.add('is-simple');
        return;
      }

      const embeddedMap = content.querySelector(
        'aside[aria-label*="Article contents"], aside[aria-label*="Contents"], .article-toc, .article-contents'
      );

      if (embeddedMap) {
        this.classList.add('has-embedded-map');
        map.remove();
        return;
      }

      const headings = Array.from(content.querySelectorAll('h2, h3, h4, h5, h6')).filter(
        (heading) => heading.textContent.trim().length > 0
      );

      if (headings.length < 2) {
        this.classList.add('is-simple');
        map.remove();
        return;
      }

      const usedIds = new Set(
        Array.from(document.querySelectorAll('[id]'))
          .map((element) => element.id)
          .filter(Boolean)
      );
      const shortenLabels = this.dataset.shortenLabels === 'true';
      const maxLength = Number.parseInt(this.dataset.maxLabelLength, 10) || 36;
      const links = [];

      headings.forEach((heading, index) => {
        if (!heading.id) {
          const baseId = this.slugify(heading.textContent) || `article-section-${index + 1}`;
          let uniqueId = baseId;
          let suffix = 2;

          while (usedIds.has(uniqueId)) {
            uniqueId = `${baseId}-${suffix}`;
            suffix += 1;
          }

          heading.id = uniqueId;
          usedIds.add(uniqueId);
        }

        const fullTitle = heading.textContent.trim().replace(/\s+/g, ' ');
        const manualTitle = heading.dataset.tocTitle?.trim();
        const visibleTitle = manualTitle || (shortenLabels ? this.shorten(fullTitle, maxLength) : fullTitle);
        const item = document.createElement('li');
        const link = document.createElement('a');
        const level = Number.parseInt(heading.tagName.slice(1), 10);

        item.style.setProperty('--article-map-level', String(Math.max(0, level - 2)));
        link.href = `#${heading.id}`;
        link.textContent = visibleTitle;
        link.title = fullTitle;
        link.setAttribute('aria-label', fullTitle);
        item.append(link);
        list.append(item);
        links.push({ heading, link });
      });

      map.hidden = false;
      this.links = links;
      this.mapNav = map.querySelector('nav');
      this.syncDisclosure();
      this.mediaQuery = window.matchMedia('(min-width: 990px)');
      this.handleMediaChange = () => this.syncDisclosure();
      this.mediaQuery.addEventListener('change', this.handleMediaChange);

      list.addEventListener('click', (event) => {
        const link = event.target.closest('a');
        if (!link) return;

        const target = content.querySelector(`#${CSS.escape(link.hash.slice(1))}`);
        if (!target) return;

        event.preventDefault();
        this.setActiveLink(link);
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
        history.replaceState(null, '', link.hash);

        if (!this.mediaQuery.matches) {
          map.querySelector('details')?.removeAttribute('open');
        }
      });

      this.handleScroll = () => {
        if (this.scrollFrame) return;

        this.scrollFrame = window.requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updateActiveHeading();
        });
      };

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll, { passive: true });
      this.updateActiveHeading();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
      this.mediaQuery?.removeEventListener('change', this.handleMediaChange);

      if (this.scrollFrame) {
        window.cancelAnimationFrame(this.scrollFrame);
      }
    }

    updateActiveHeading() {
      if (!this.links?.length) return;

      const offset = 140;
      let active = this.links[0];

      for (const item of this.links) {
        if (item.heading.getBoundingClientRect().top <= offset) {
          active = item;
        } else {
          break;
        }
      }

      this.setActiveLink(active.link);
    }

    setActiveLink(activeLink) {
      this.links.forEach(({ link }) => {
        if (link === activeLink) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });

      if (!this.mediaQuery?.matches || !this.mapNav) return;

      const linkTop = activeLink.offsetTop;
      const linkBottom = linkTop + activeLink.offsetHeight;
      const visibleTop = this.mapNav.scrollTop;
      const visibleBottom = visibleTop + this.mapNav.clientHeight;

      if (linkTop < visibleTop || linkBottom > visibleBottom) {
        activeLink.scrollIntoView({ block: 'nearest' });
      }
    }

    syncDisclosure() {
      const details = this.querySelector('[data-article-map] details');
      if (!details) return;

      if (window.matchMedia('(min-width: 990px)').matches) {
        details.setAttribute('open', '');
      } else {
        details.removeAttribute('open');
      }
    }

    shorten(title, maxLength) {
      const cleaned = title.replace(/[?!.\s]+$/g, '').replace(/\s+/g, ' ').trim();
      const capacity = cleaned.match(/\b(?:for|seats?)\s+(\d+)\s+(?:people|persons?)\b/i);

      if (capacity && /\b(?:size|dimensions?|table)\b/i.test(cleaned)) {
        return `${capacity[1]} people`;
      }

      const colonIndex = cleaned.indexOf(':');
      if (colonIndex > 4 && colonIndex <= maxLength) {
        return cleaned.slice(0, colonIndex);
      }

      let label = cleaned
        .replace(/^(?:what|which)\s+(?:is|are|does|do|should|can)\s+(?:the\s+)?/i, '')
        .replace(/^how\s+(?:to|do|does|can|should)\s+/i, '')
        .replace(/^why\s+(?:is|are|do|does|should)\s+/i, '')
        .replace(/^when\s+(?:to|do|does|should)\s+/i, '')
        .replace(/^(?:a|an|the)\s+/i, '');

      if (label.length <= maxLength) return label;

      const words = label.split(' ');
      let shortened = '';

      for (const word of words) {
        const candidate = shortened ? `${shortened} ${word}` : word;
        if (candidate.length > maxLength - 1) break;
        shortened = candidate;
      }

      return `${shortened || label.slice(0, maxLength - 1).trim()}…`;
    }

    slugify(value) {
      return value
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }
  }

  if (!customElements.get('article-map')) {
    customElements.define('article-map', ArticleMap);
  }
  } catch(e) { console.error(e); }
})();

})();
